/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "store";
import videojs from "video.js";

import { getVideoJsComponent } from "../utils";

import type Player from "video.js/dist/types/player";

/**
 * HACK: theoplayerの読み込みが完了する前にこのモジュールがインポートされると、
 * getVideoJsComponent内でwindow.THEOplayerがundefinedとなりエラーになるため、
 * 関数としてエクスポートし、必要なときに呼び出す形にする。
 * 本当はnpm管理のtheoplayerパッケージを使いたいが、検証が不十分なため現状はこの方法で対応。
 */
export const getVideoJsMultiAngleSwitcherComponent = () => {
  const VideoJSComponent = getVideoJsComponent("Component");

  /**
   * videojsでReactコンポーネントを表示するためのラッパーコンポーネント
   * @see https://videojs.org/guides/react/
   */
  class MultiAngleSwitcher extends VideoJSComponent {
    constructor(player: Player, options = {}) {
      super(player, options);
      // Bind the current class context to the mountReactComponent method
      this.mountReactComponent = this.mountReactComponent.bind(this);
      // When player is ready, call method to mount the React component
      player.ready(() => this.mountReactComponent());
    }

    mountReactComponent() {
      ReactDOM.render(
        <Provider store={store}>
          <div>Multi Angle Switcher Component</div>
        </Provider>,
        this.el()
      );
    }

    createEl() {
      const el = videojs.dom.createEl("div") as HTMLElement;
      return el;
    }
    dispose(options?: { originalEl: Element }): void {
      ReactDOM.unmountComponentAtNode(this.el());
      super.dispose(options);
    }
  }

  return MultiAngleSwitcher;
};
